import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import FormControl, { FormControlProps } from "@material-ui/core/FormControl";
import InputLabel, { InputLabelProps } from "@material-ui/core/InputLabel";
import Select, { SelectProps } from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

// @material-ui/icons
import Clear from "@material-ui/icons/Clear";
import Check from "@material-ui/icons/Check";

// core components (mesmo style do CustomInput)
import styles from "assets/jss/material-dashboard-react/components/customInputStyle.js";

{/*@ts-ignore*/}
const useStyles = makeStyles(styles);

// Tipo das opções do select
export interface SelectOption<T extends string | number = any> {
  label: string;
  value: T;
}

export interface CustomSelectProps<T extends string | number = any> {
  labelText?: React.ReactNode;
  labelProps?: InputLabelProps;
  id?: string;
  value: T;
  onChange: (event: React.ChangeEvent<{ value: unknown }>) => void;
  options: SelectOption<T>[];
  formControlProps?: FormControlProps;
  selectProps?: SelectProps;
  error?: boolean;
  success?: boolean;
}

export default function CustomSelect<T extends string | number = any>(
    props: CustomSelectProps<T>
) {
  const classes = useStyles();

  const {
    formControlProps,
    labelText,
    id,
    labelProps,
    value,
    onChange,
    options,
    error,
    success,
    selectProps
  } = props;

  const labelClasses = classNames({
    [" " + classes.labelRootError]: error,
    [" " + classes.labelRootSuccess]: success && !error
  });

  const underlineClasses = classNames({
    [classes.underlineError]: error,
    [classes.underlineSuccess]: success && !error,
    [classes.underline]: true
  });

  return (
    <FormControl
      {...formControlProps}
      className={`${formControlProps?.className || ""} ${classes.formControl}`}
    >
      {labelText && (
        <InputLabel
          className={classes.labelRoot + labelClasses}
          htmlFor={id}
          {...labelProps}
        >
          {labelText}
        </InputLabel>
      )}
      <Select
        value={value}
        onChange={onChange}
        inputProps={{ id }}
        classes={{
          root: classes.marginTop,
          disabled: classes.disabled
        }}
        {...selectProps}
      >
        {options.map((opt) => (
          <MenuItem key={String(opt.value)} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>

      {error ? (
        <Clear className={classes.feedback + " " + classes.labelRootError} />
      ) : success ? (
        <Check className={classes.feedback + " " + classes.labelRootSuccess} />
      ) : null}
    </FormControl>
  );
}

CustomSelect.propTypes = {
  labelText: PropTypes.node,
  labelProps: PropTypes.object,
  id: PropTypes.string,
  formControlProps: PropTypes.object,
  selectProps: PropTypes.object,
  error: PropTypes.bool,
  success: PropTypes.bool
};
